import { ServiceAdapter } from './serviceAdapter';

export class DirectSalesAdapter extends ServiceAdapter {
  static adaptItems(items) {
    return items.map(item => ({
      id: item.id,
      name: item.title,
      brand: item.brand,
      category: item.category,
      area: 'Vendas Diretas',
      price: item.price,
    }));
  }

  static adaptItem(item) {
    if (!item) return null;

    return {
      id: item.id,
      name: item.title,
      brand: item.brand,
      category: item.category,
      area: 'Vendas Diretas',
      price: item.price,
    };
  }
}
